import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { LicenseMarketplace } from '@/routes/_staff/marketplace/_store/store/licenses/-components/LicenseMarketplace';
import { SearchSchema } from '@/routes/_staff/marketplace/_store/store/licenses/-zod-schema';
export const Route = createFileRoute('/_staff/marketplace/_store/store/licenses/')({
  component: LicenseMarketplace,
  validateSearch: zodValidator(SearchSchema)
});